
    import './styles.scoped.css';
    export default {
  "dialog": "awsui_dialog_1d2i7_b278u_11",
  "modal-slide-up": "awsui_modal-slide-up_1d2i7_b278u_1",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_b278u_1",
  "refresh": "awsui_refresh_1d2i7_b278u_34",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_b278u_1",
  "root": "awsui_root_1d2i7_b278u_67",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_b278u_1",
  "hidden": "awsui_hidden_1d2i7_b278u_124",
  "focus-lock": "awsui_focus-lock_1d2i7_b278u_128",
  "small": "awsui_small_1d2i7_b278u_146",
  "medium": "awsui_medium_1d2i7_b278u_149",
  "large": "awsui_large_1d2i7_b278u_152",
  "max": "awsui_max_1d2i7_b278u_155",
  "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_b278u_155",
  "container": "awsui_container_1d2i7_b278u_160",
  "content": "awsui_content_1d2i7_b278u_183",
  "no-paddings": "awsui_no-paddings_1d2i7_b278u_186",
  "header": "awsui_header_1d2i7_b278u_190",
  "header--text": "awsui_header--text_1d2i7_b278u_197",
  "footer": "awsui_footer_1d2i7_b278u_201",
  "dismiss-control": "awsui_dismiss-control_1d2i7_b278u_211",
  "modal-open": "awsui_modal-open_1d2i7_b278u_215"
};
  